export const environment = {
  production: false,
  apiFQDN: 'https://api.dev.airodis.acoemcloud.com',
  documentationDomain: 'https://acoem.gitbook.io/acloud',
  keycloakClientId: 'acloud-dev',
  keycloakRealm: 'acoem',
  keycloakBaseUrl: 'https://auth.acoem.com',
};
